import { FC } from "react";
import styles from "./Advantages.module.scss";
import { getScreenSize } from "@utils/getScreenSize";
import { Swiper, SwiperSlide } from "swiper/react";
import cn from "classnames";

const Advantages: FC = () => {
    const { isMobile } = getScreenSize();
    return (
        <section className={styles.advantages}>
            <div className={styles.headline}>
                <h2 className={styles.title}>Advantages</h2>
            </div>
            {isMobile ? (
                <Swiper
                    pagination
                    className={styles.items + " !overflow-visible"}
                    spaceBetween={20}
                    updateOnWindowResize
                    slidesPerView={1.1}
                >
                    <SwiperSlide>
                        <div className={cn(styles.item, styles.speed)}>
                            <div className={styles.text}>
                                <h3 className={styles.itemTitle}>Speed</h3>
                                <p className={styles.description}>
                                    We tried to speed up trading by using clean code and fast technologies. A separate
                                    power is allocated for each sniper bot
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className={cn(styles.item, styles.simplicity)}>
                            <div className={styles.text}>
                                <h3 className={styles.itemTitle}>Simplicity</h3>
                                <p className={styles.description}>
                                    Use a convenient and intuitive interface for trading, all the necessary information
                                    is on one screen.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className={cn(styles.item, styles.availability)}>
                            <div className={styles.text}>
                                <h3 className={styles.itemTitle}>Availability</h3>
                                <p className={styles.description}>
                                    We have tried to make our products available to everyone, make a profit today
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            ) : (
                <div className={styles.items}>
                    <div className={styles.item}>
                        <div className={styles.text}>
                            <h3 className={styles.itemTitle}>Speed</h3>
                            <p className={styles.description}>
                                We tried to speed up trading by using clean code and fast technologies. A separate power
                                is allocated for each sniper bot
                            </p>
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.text}>
                            <h3 className={styles.itemTitle}>Simplicity</h3>
                            <p className={styles.description}>
                                Use a convenient and intuitive interface for trading, all the necessary information is
                                on one screen.
                            </p>
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.text}>
                            <h3 className={styles.itemTitle}>Availability</h3>
                            <p className={styles.description}>
                                We have tried to make our products available to everyone, make a profit today
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Advantages;
